module.exports = __webpack_public_path__ + "img/empty-header.e7215622.webp";